import {
    BooleanIconRenderer, CheckboxRenderer,
    DateRenderer, EmailRenderer, LinkRenderer,
    GridColumnType, PhoneRenderer, ToggleRenderer,
    WithCopyable, WithOverflow, withIconAddon,
    BadgeRenderer
} from "@repo/design-system/components/grids";
import { Iconify } from "@repo/design-system/components/ui";

const getBaseRenderer = (col, columnEvents) => {
    switch (col.type) {

        case GridColumnType.ACTION:
            return col._resolvedActions ? col._actionRenderer : null;

        case GridColumnType.DATE:
            return (rowData) => DateRenderer(col)(rowData);

        case GridColumnType.EMAIL:
            return (rowData) => EmailRenderer(col)(rowData);

        case GridColumnType.PHONE:
            return (rowData) => PhoneRenderer(col)(rowData);

        case GridColumnType.LINK:
            return (rowData) => LinkRenderer(col)(rowData);

        case GridColumnType.CHECKBOX:
            return (rowData) => CheckboxRenderer(col, columnEvents)(rowData);

        case GridColumnType.TOGGLE:
            return (rowData) => ToggleRenderer(col, columnEvents)(rowData);

        case GridColumnType.ICON:
            return (rowData) => BooleanIconRenderer(col)(rowData);

        case GridColumnType.BADGE:
            return (rowData) => BadgeRenderer(col, columnEvents)(rowData);

        default:
            return (rowData, options) => {
                if (typeof col.body === "function") {
                    return col.body(rowData, options);
                }
                if (col.expander) {
                    const isExpanded = Boolean(
                        options?.isExpanded ||
                        (options?.props?.expandedRows && rowData?.studentId != null && Boolean(options.props.expandedRows[rowData.studentId])) ||
                        (options?.props?.expandedRows && options?.rowIndex != null && Boolean(options.props.expandedRows[options.rowIndex]))
                    );

                    return (
                        <Iconify
                            icon={isExpanded ? "lucide:chevron-down" : "lucide:chevron-right"}
                            width={16}
                            height={16}
                            className={`sag-expander-icon text-secondary ${isExpanded ? "expanded" : ""}`}
                        />
                    );
                }
                const value = rowData?.[col.field];
                return value !== null && value !== undefined && value !== ""
                    ? value : "-";
            };
    }
};
const withOverflow = (renderer, col) => {
    return (rowData) => WithOverflow(renderer, col)(rowData);
};
const withCopyable = (renderer, col) => {
    if (!col?.config?.copyable) return renderer;
    return (rowData) => WithCopyable(renderer, col)(rowData);
};
const withIconWrapper = (renderer, col, columnEvents) => {
    if (!col?.config?.withIconWrapper?.icon) return renderer;
    return (rowData) => withIconAddon(renderer, col, columnEvents)(rowData);
};

export const composeColumnRenderer = (col, columnEvents) => {
    let renderer = getBaseRenderer(col, columnEvents);
    if (!renderer) return null;

    renderer = withCopyable(renderer, col);
    if (col.type !== GridColumnType.ACTION && !col.expander && !col.disableOverflow) {
        renderer = withOverflow(renderer, col);
    }
    renderer = withIconWrapper(renderer, col, columnEvents);

    return renderer;
};